// Waits until typing stops before letting a value through.
//
// Without this, every keystroke in the POS search box would fire a request.
// Two hundred and fifty milliseconds is short enough to feel instant and long
// enough that a five-letter word costs one request rather than five.

import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
